import { useCallback, useEffect, useState } from 'react';
import calculateMenuPosition from '../../helpers/calculate-menu-position';
import { ReactSelectInstanceRefObject } from '../../custom-react-select.types';

type Params = {
  selectRef: ReactSelectInstanceRefObject;
  containerRef?: React.RefObject<HTMLDivElement | null>;
  dynamicMenuPlacement?: boolean;
  dynamicMenuPlacementOffset?: number;
  isOpen: boolean;
};

const useGetMenuPlacement = ({
  selectRef,
  containerRef,
  dynamicMenuPlacementOffset,
  dynamicMenuPlacement,
  isOpen,
}: Params) => {
  const [menuPlacement, setMenuPlacement] = useState<'top' | 'bottom' | 'auto'>('auto');

  const getDynamicMenuPlacement = useCallback(() => {
    setMenuPlacement(
      calculateMenuPosition({
        selectRef,
        containerRef,
        dynamicMenuPlacement,
        dynamicMenuPlacementOffset,
        menuClass: '.truncated-creatable-multi-react-select__menu',
      })
    );
  }, [selectRef, containerRef, dynamicMenuPlacement, dynamicMenuPlacementOffset]);

  useEffect(() => {
    if (dynamicMenuPlacement) {
      getDynamicMenuPlacement();
    }
  }, [dynamicMenuPlacement, getDynamicMenuPlacement, isOpen]);

  return {
    menuPlacement,
  };
};

export default useGetMenuPlacement;
